@if(items?.length && items?.length > 2) {
  <div class="filter">
    @if (!isMobile) {
        <mat-form-field color="primary" appearance="outline"  class="filter-filed">
          <mat-select [formControl]="selected" color="primary" placeholder="Select from list" [multiple]="true">
              <mat-option>
                <ngx-mat-select-search 
                    [showToggleAllCheckbox]="false"
                    [formControl]="searchFilterCtrl" 
                    [placeholderLabel]="'Search'" 
                    noEntriesFoundLabel="No matching results found" />
              </mat-option>
            @for (item of filtered(); track item) {
              <mat-option [value]="item">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
    }
    @if (isMobile) {
      <button class="filter-button p-0 w-3rem min-w-0" mat-stroked-button color="primary"
        (click)="opneFilerMenu()" [matBadge]="selected.value?.length" [matBadgeHidden]="allFilters">
        <mat-icon class="notranslate m-0">filter_list</mat-icon>
      </button>
  }
  </div>
}
